const CORE_API = 'https://backproject.meanc.net';
const CHAT_API = 'https://chat.meanc.net';

const buildHeaders = (headers = {}) => {
  const token = localStorage.getItem('meanc_access');
  const authHeaders = token ? { Authorization: `Bearer ${token}` } : {};
  return {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...authHeaders,
    ...headers,
  };
};

const handleResponse = async (response) => {
  const text = await response.text();
  const data = text ? JSON.parse(text) : null;
  if (!response.ok) {
    const error = new Error(data?.detail || data?.error || 'API request failed');
    error.status = response.status;
    error.payload = data;
    throw error;
  }
  return data;
};

export const apiFetch = (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${CORE_API}${endpoint}`;
  return fetch(url, {
    ...options,
    headers: buildHeaders(options.headers),
  }).then(handleResponse);
};

export const apiFetchNoJson = (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${CORE_API}${endpoint}`;
  return fetch(url, {
    ...options,
    headers: buildHeaders(options.headers),
  });
};

export const chatFetch = (endpoint, options = {}) => {
  const url = endpoint.startsWith('http') ? endpoint : `${CHAT_API}${endpoint}`;
  return fetch(url, {
    ...options,
    headers: buildHeaders(options.headers),
  }).then(handleResponse);
};

export const extractErrorMessage = (error, fallback = 'Unable to complete request.') => {
  if (!error) return fallback;
  if (error.payload?.detail) return error.payload.detail;
  if (error.payload?.error) return error.payload.error;
  return error.message || fallback;
};
